export enum PayoutCsvExportType {
  ORIGINAL = 'original',
  FINANCIAL_TIME = '2024.3.1',
}
